import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { FaMapMarkerAlt, FaPhone, FaLanguage, FaCode, FaShoppingCart, FaBookOpen, FaPhoneVolume } from 'react-icons/fa'; // Importing icons
import { GiFountainPen } from "react-icons/gi";
import logo from '../../assets/logo.svg';
import './CustomNavbar.css';
import { Link } from 'react-router-dom';
import { MdOutlineMenuBook } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import RegionSwitcher from '../RegionSwitcher/RegionSwitcher';

function CustomNavbar() {
  const [expanded, setExpanded] = useState(false);
  const { i18n, t } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'ga');

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    const newLang = nextChecked ? 'ga' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <div>
      <Navbar className='white-bg margin-left' variant="light" expand="lg" expanded={expanded} >
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}

            className="d-inline-block align-top custom-nav-logo"
            alt="title"
          />
        </Navbar.Brand>

        <div className='custom-nav-menu'>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)} />
          <div className='left-align-items'>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="c-nav-menu">
                <Nav.Link href="/contact-us#contact-form-section">
                  <GiFountainPen /> {t("Enquire Now")}
                </Nav.Link>
                {/* <Nav.Link href="/contact-us">
                  <FaPhone /> {t('Contact us')}
                </Nav.Link> */}
                {/* <div className='language-switcher'>
                  <FaLanguage className="language-icon" />
                  <button
                    className={`language-btn ${!checked ? 'active' : ''}`}
                    onClick={() => handleChange(false)}
                    title="English"
                  >
                    EN
                  </button>
                  <button
                    className={`language-btn ${checked ? 'active' : ''}`}
                    onClick={() => handleChange(true)}
                    title="Irish"
                  >
                    GA
                  </button>
                </div> */}
                {/* <RegionSwitcher /> */}
                <Nav.Link href="https://shop.hansa-flex.ie/" target="_blank" rel="noopener noreferrer">
                  {/* <FaShoppingCart /><MdOutlineMenuBook />  */}
                  <FaBookOpen /> {t('Online-Catalogue')}

                </Nav.Link>
                <Nav.Link href="https://my.hansa-flex.ie/" target="_blank" rel="noopener noreferrer">
                  <FaCode />  {t('X-CODE Manager')}

                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
          <div className='custom-nav-menu-contact'>
            Get in Touch with HANSA-FLEX Ireland
            <span className=''>
              <FaPhoneVolume /> NI: <a href="tel:+44 028 90833813">(0044) 028 90833813 (NI)</a>
            </span>
            <span className=''>
              <FaPhoneVolume /> ROI: <a href="tel:+353 01 6251962">(00353) 01 6251962 (ROI)</a>
            </span>
          </div>
        </div>

      </Navbar>
    </div>
  );
}

export default CustomNavbar;
